import { useTpmInvoices } from '@/context/services/tpm/hooks';
import { createBusinessPersonData } from '@/context/services/tpm/utils';
import { useTranslation } from '@/i18n';
import {
  Caption,
  RegistrationBusinessPersonDataPopover,
} from '@moneyforward/ap-frontend-components';
import { ApprovingInvoiceReportFormInputResponse } from 'ap-openapi';
import classNames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import styles from '../../styles.module.scss';
import { randomId } from '@/wc/helper/render';

type InvoiceRegistrationNumberFieldViewProps = {
  item: ApprovingInvoiceReportFormInputResponse;
  mismatchCaption?: string;
};

export const InvoiceRegistrationNumberFieldView: FC<InvoiceRegistrationNumberFieldViewProps> =
  memo(({ item, mismatchCaption }) => {
    const cx = classNames.bind(styles);
    const { t } = useTranslation();
    const tpmData = useTpmInvoices(item?.input_values?.[0]?.value ?? '');
    const labelSettings = useMemo(() => {
      return {
        termLabelSettings: {
          label: t('registration_business_person_data_term'),
        },
        companyTypeLabelSettings: {
          label: t('registration_business_person_data_company_type'),
        },
      };
    }, [t]);
    return (
      <>
        <div
          className={cx(
            `registrationNumberContainer${
              item?.input_values?.[0]?.value ? '' : '_Between'
            }`
          )}
        >
          <div>
            {item?.input_values?.[0]?.value
              ? `T${item.input_values[0].value}`
              : ''}
          </div>
          <RegistrationBusinessPersonDataPopover
            {...createBusinessPersonData(tpmData, false)}
            termLabelSettings={labelSettings.termLabelSettings}
            companyTypeLabelSettings={labelSettings.companyTypeLabelSettings}
            key={randomId(`${item?.input_values?.[0]?.id}`, 8)}
          />
        </div>

        <div>
          {item?.input_additional_values?.[0] &&
          'is_mismatched' in item.input_additional_values[0] &&
          item?.input_additional_values[0]?.is_mismatched ? (
            <Caption type='alert'>
              {t('invoice_registration_number_mismatched')}
            </Caption>
          ) : null}
          {mismatchCaption && <Caption type='alert'>{mismatchCaption}</Caption>}
        </div>
      </>
    );
  });

InvoiceRegistrationNumberFieldView.displayName =
  'InvoiceRegistrationNumberFieldView';
